module.exports = __webpack_public_path__ + "static/media/6.3ee92c99.png";